import { CeruleanButton } from 'components/Button'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`

export const Label = styled.label`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 150%;
  color: ${color('grey600')};
`

export const Input = styled.input`
  font-weight: 500;
  font-size: 1rem;
  line-height: 150%;
  padding: 1rem;
  color: ${color('dark')};
  border: 1px solid ${color('dark500')};
  border-radius: 4px;
  background-color: transparent;
`

export const Error = styled.small`
  font-weight: 500;
  color: ${color('error')};
  font-size: 0.75rem;
  min-height: 1rem;
`

export const InfoPill = styled.div<{
  $isError?: boolean
}>`
  display: flex;
  margin-top: 0.5rem;
  width: max-content;
  padding: 0.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  background-color: ${({ $isError }) => ($isError ? color('red000') : color('dark700'))};
  color: ${({ $isError }) => ($isError ? color('error') : color('dark'))};
`

export const Button = styled(CeruleanButton)`
  width: 100%;
`
